import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getToolsEntitiesList, getToolsLoadedStatus, LoadTools } from './../../../../ng2/store';

@Injectable()
export class ToolsResolver {
  resolveAllTools$(currentSchool, Store): Promise<Observable<any>> {
    const payload = { schoolId: currentSchool._id };
    const destroy$: Subject<boolean> = new Subject<boolean>();
    return new Promise(resolve => {
      Store.select(getToolsLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) Store.dispatch(new LoadTools(payload));
          if (loaded) {
            const tools$ = Store.select(getToolsEntitiesList);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(tools$);
          }
        });
    });
  }
  resolveToolsLoadedStatus(Store): Promise<any> {
    const destroy$: Subject<boolean> = new Subject<boolean>();
    return new Promise(resolve => {
      Store.select(getToolsLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          resolve(loaded);
        });
    });
  }
}
